import { Automarke, KfzTypSelectOption } from '@gsm/entities';
import { AND_OPERATOR, DYNAMIC_FORM_CONTROL_TYPE_GROUP, DYNAMIC_FORM_CONTROL_TYPE_INPUT, DYNAMIC_FORM_CONTROL_TYPE_SELECT, DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA, DynamicFormOptionConfig, MATCH_HIDDEN, MATCH_VISIBLE, OR_OPERATOR } from '@ng-dynamic-forms/core';
import { TYPE_GESCHAEDIGTES_FAHRZEUG } from '../geschaedigtes-fahrzeug/geschaedigtes-fahrzeug.model';
import { TYPE_SELECT_FILTER } from '../select-filter/select-filter.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';

export type FormModelFactory = (args?: [] | null) => AnyFormControlModel[];

export const PERSON_FORM_MODEL: FormModelFactory = () => [
  {
    id:            'info',
    type:          'INFO',
    content:       'Bitte erfassen Sie eine Person.',
    isInstruction: true
  },
  {
    id:    'person_erfassen',
    type:  DYNAMIC_FORM_CONTROL_TYPE_GROUP,
    group: [
      {
        id:            'vorname',
        placeholder:   'Bitte geben Sie den Vornamen der geschädigten Person ein.',
        label:         'Vorname',
        validators:    {
          maxLength: 25
        },
        errorMessages: {
          alphanum:  'Bitte geben Sie einen gültigen Vornamen an',
          maxLength: 'Bitte geben Sie maximal 25 Zeichen ein.'
        },
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT
      },
      {
        id:            'nachname',
        placeholder:   'Bitte geben Sie den Nachnamen der geschädigten Person an.',
        label:         'Nachname/Firmenname',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        required:      true,
        validators:    {
          minLength: 2,
          required:  null,
          maxLength: 60
        },
        errorMessages: {
          minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
          alphanum:  'Bitte geben Sie einen gültigen Nachnamen ein',
          required:  '{{ label }} ist ein Pflichtfeld.',
          maxLength: 'Bitte geben Sie maximal 60 Zeichen ein.'
        }
      },
      {
        id:            'notiz',
        placeholder:   'Bitte geben Sie eine Notiz an.',
        label:         'Notiz',
        validators:    {
          maxLength: 300
        },
        errorMessages: {
          maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
        },
        type:          DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA
      }
    ]
  }
];

export const SACHE_FORM_MODEL: FormModelFactory = () => [
  {
    id:    'sache_erfassen',
    type:  DYNAMIC_FORM_CONTROL_TYPE_GROUP,
    group: [
      {
        id:            'info',
        type:          'INFO',
        content:       'Bitte erfassen Sie die beschädigte/n Sache/n.',
        isInstruction: true
      },
      {
        id:            'beschreibung',
        placeholder:   'Geben Sie bitte die Bezeichnung der Sache bekannt. (z.B. Gartenmauer)',
        label:         'Bezeichnung',
        validators:    {
          minLength: 2,
          maxLength: 300
        },
        errorMessages: {
          minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
          required:  '{{ label }} ist ein Pflichtfeld.',
          maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
        },
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        required:      true
      }
    ]
  },
  {
    id:    'sache_erfassen_anspruchsteller',
    type:  DYNAMIC_FORM_CONTROL_TYPE_GROUP,
    group: [
      {
        id:            'info',
        type:          'INFO',
        content:       'Bitte geben Sie die Daten des Anspruchstellers bekannt.',
        isInstruction: true
      },
      {
        id:            'vorname',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'Vorname',
        placeholder:   'Bitte geben Sie den Vornamen des Anspruchstellers an.',
        validators:    {
          maxLength: 25
        },
        errorMessages: {
          alphanum:  'Bitte geben Sie einen gültigen Vornamen ein',
          maxLength: 'Bitte geben Sie maximal 25 Zeichen ein.'
        }
      },
      {
        id:            'nachname',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'Nachname/Firmenname',
        placeholder:   'Bitte geben Sie den Nachnamen des Anspruchstellers an.',
        validators:    {
          minLength: 2,
          maxLength: 60
        },
        errorMessages: {
          minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
          alphanum:  'Bitte geben Sie einen gültigen Nachnamen ein.',
          maxLength: 'Bitte geben Sie maximal 60 Zeichen ein.'
        }
      },
      {
        id:            'plz',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'PLZ',
        placeholder:   'Bitte geben Sie die PLZ des Anspruchstellers an.',
        validators:    {
          maxLength: 8,
          alphanum:  {
            letterRequired: false
          }
        },
        errorMessages: {
          alphanum:  'Bitte geben Sie eine gültige {{label}} ein.',
          maxLength: 'Bitte geben Sie maximal 8 Zeichen ein.'
        }
      },
      {
        id:            'ort',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'Ort',
        placeholder:   'Bitte geben Sie den Ort des Anspruchstellers an.',
        validators:    {
          minLength: 2,
          maxLength: 30
        },
        errorMessages: {
          alphanum:  'Bitte geben Sie einen gültigen {{label}} ein.',
          minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
          maxLength: 'Bitte geben Sie maximal 30 Zeichen ein.'
        }
      },
      {
        id:            'strasse',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'Straße',
        placeholder:   'Bitte geben Sie die Straße des Anspruchstellers an.',
        validators:    {
          minLength: 2,
          alphanum:  null,
          maxLength: 45
        },
        errorMessages: {
          alphanum:  'Bitte geben Sie eine gültige {{label}} ein.',
          minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
          maxLength: 'Bitte geben Sie maximal 45 Zeichen ein.'
        }
      },
      {
        id:            'hausNummer',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'Hausnummer',
        placeholder:   'Bitte geben Sie die Hausnummer des Anspruchstellers an.',
        validators:    {
          alphanum:  {
            letterRequired: false
          },
          maxLength: 7
        },
        errorMessages: {
          alphanum:  'Bitte geben Sie eine gültige {{label}} ein.',
          maxLength: 'Bitte geben Sie maximal 7 Zeichen ein.'
        }
      },
      {
        id:            'land',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'Land',
        placeholder:   'Bitte geben Sie das Land des Anspruchstellers an.',
        value:         'Österreich',
        validators:    {
          maxLength: 300
        },
        errorMessages: {
          alphanum:  'Bitte nur Buchstaben eingeben.',
          maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
        }
      },
      {
        id:            'email',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'E-Mail Adresse',
        placeholder:   'Bitte geben Sie die E-Mail Adresse des Anspruchstellers an.',
        validators:    {
          email:     null,
          maxLength: 300
        },
        errorMessages: {
          email:     'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
          maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
        }
      },
      {
        id:            'telephoneNumber',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        label:         'Telefonnummer',
        placeholder:   'Bitte geben Sie die Telefonnummer des Anspruchstellers an.',
        validators:    {
          phone:     null,
          maxLength: 300
        },
        errorMessages: {
          phone:     'Bitte geben Sie eine gültige {{label}} ein.',
          maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
        }
      }
    ]
  }
];

export function KFZ_FORM_MODEL(automarken: Automarke[] = [], carTypes: KfzTypSelectOption[] = []): AnyFormControlModel[] {
  const markeOptions: DynamicFormOptionConfig<Automarke>[] = automarken.map(marke => ({
    label: marke.label,
    value: marke
  }));
  return [
    {
      id:            'info',
      type:          'INFO',
      content:       'Bitte erfassen Sie das gegnerische Fahrzeug.',
      isInstruction: true
    },
    {
      id:    'kfz_erfassen',
      type:  DYNAMIC_FORM_CONTROL_TYPE_GROUP,
      group: [
        {
          id:          'eigentum',
          label:       'Eigentum des Versicherungsnehmers?',
          placeholder: 'Ist das geschädigte KFZ im Eigentum des Versicherungsnehmers?',
          type:        DYNAMIC_FORM_CONTROL_TYPE_SELECT,
          required:    true,
          options:     [
            {label:  'Ja',
              value: true
            },
            {label:  'Nein',
              value: false
            }
          ]
        },
        {
          id:            'marke',
          label:         'Marke',
          placeholder:   'Bitte geben Sie die Marke an.',
          type:          TYPE_SELECT_FILTER,
          optionMatcher: ['value'],
          options:       markeOptions,
          validators:    {
            maxLength: 300
          },
          errorMessages: {
            maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
          },
          relations:     [
            {
              match: MATCH_HIDDEN,
              when:  [
                {
                  id:    'eigentum',
                  value: true
                }
              ]
            }
          ]
        },
        {
          id:            'modell',
          label:         'Modell',
          placeholder:   'Bitte geben Sie ein Modell an.',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          validators:    {
            maxLength: 300
          },
          errorMessages: {
            maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
          },
          relations:     [
            {
              match: MATCH_HIDDEN,
              when:  [
                {
                  id:    'eigentum',
                  value: true
                }
              ]
            }
          ]
        },
        {
          id:            'kennzeichen_info',
          type:          'INFO',
          content:       'Ist das Kennzeichen des KFZ bekannt?',
          isInstruction: true,
          relations:     [
            {
              match: MATCH_HIDDEN,
              when:  [
                {
                  id:    'eigentum',
                  value: true
                }
              ]
            }
          ]
        },
        {
          id:            'kennzeichenBekannt',
          label:         'Kennzeichen bekannt',
          type:          DYNAMIC_FORM_CONTROL_TYPE_SELECT,
          required:      true,
          options:       [
            {
              label: 'Ja',
              value: true
            },
            {
              label: 'Nein',
              value: false
            }
          ],
          relations:     [
            {
              match: MATCH_HIDDEN,
              when:  [
                {
                  id:    'eigentum',
                  value: true
                }
              ]
            }
          ],
          additional:    {
            hideLog: true
          },
          errorMessages: {
            required: '{{ label }} ist ein Pflichtfeld.'
          }
        },
        {
          id:            'kennzeichen',
          label:         'Kennzeichen',
          placeholder:   'Bitte geben Sie das Kennzeichen an.',
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          hidden:        true,
          required:      true,
          validators:    {
            required:  null,
            maxLength: 10,
            alphanum:  null
          },
          errorMessages: {
            required:  '{{label}} ist ein Pflichtfeld.',
            alphanum:  'Bitte geben Sie ein gültiges Kennzeichen ein.',
            maxLength: 'Bitte geben Sie maximal 10 Zeichen ein.'
          },
          relations:     [
            {
              match:    MATCH_VISIBLE,
              operator: OR_OPERATOR,
              when:     [
                {
                  id:    'kennzeichenBekannt',
                  value: true
                },
                {
                  id:    'eigentum',
                  value: true
                }
              ]
            }
          ]
        },
        {
          id:            'kennzeichenUnbekanntBegruendung',
          label:         'Begründung',
          placeholder:   'Bitte geben Sie eine Begründung an, warum das Kennzeichen unbekannt ist.',
          validators:    {
            minLength: 2,
            required:  null,
            maxLength: 300
          },
          errorMessages: {
            required:  '{{ label }} ist ein Pflichtfeld.',
            minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
            maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
          },
          type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
          hidden:        true,
          required:      true,
          relations:     [
            {
              match:    MATCH_VISIBLE,
              operator: AND_OPERATOR,
              when:     [
                {
                  id:    'kennzeichenBekannt',
                  value: false
                },
                {
                  id:    'eigentum',
                  value: false
                }
              ]
            }
          ]
        },
        {
          id:            'fahrzeughalter_info',
          type:          'INFO',
          content:       'Fahrzeughalter',
          isInstruction: true,
          relations:     [
            {
              match: MATCH_VISIBLE,
              when:  [
                {
                  id:    'eigentum',
                  value: false
                }
              ]
            }
          ]
        },
        {
          id:        'person',
          type:      DYNAMIC_FORM_CONTROL_TYPE_GROUP,
          group:     [
            {
              id:            'vorname',
              label:         'Vorname',
              placeholder:   'Bitte geben Sie einen Vornamen ein.',
              validators:    {
                maxLength: 25
              },
              errorMessages: {
                alphanum:  'Bitte geben Sie einen gültigen Vornamen ein',
                maxLength: 'Bitte geben Sie maximal 25 Zeichen ein.'
              },
              type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT
            },
            {
              id:            'nachname',
              label:         'Nachname/Firmenname',
              placeholder:   'Bitte geben Sie einen Nachnamen ein.',
              validators:    {
                minLength: 2,
                maxLength: 60
              },
              errorMessages: {
                minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
                alphanum:  'Bitte geben Sie einen gültigen Nachnamen ein',
                maxLength: 'Bitte geben Sie maximal 60 Zeichen ein.'
              },
              type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT
            }
          ],
          relations: [
            {
              match: MATCH_VISIBLE,
              when:  [
                {
                  id:    'eigentum',
                  value: false
                }
              ]
            }
          ]
        },
        {
          id:           'schaden',
          type:         TYPE_GESCHAEDIGTES_FAHRZEUG,
          kfzTypesList: carTypes
        }
      ]
    }
  ];
}

export const TIER_FORM_MODEL: FormModelFactory = () => [
  {
    id:    'tier_erfassen',
    type:  DYNAMIC_FORM_CONTROL_TYPE_GROUP,
    group: [
      {
        id:            'info',
        type:          'INFO',
        content:       'Bitte erfassen Sie die Tiergattung.',
        isInstruction: true
      },
      {
        id:            'bezeichnung',
        placeholder:   'Bitte erfassen Sie die Tiergattung. (z.B.: Fuchs)',
        label:         'Tiergattung',
        type:          DYNAMIC_FORM_CONTROL_TYPE_INPUT,
        required:      true,
        validators:    {
          minLength: 2,
          maxLength: 300
        },
        errorMessages: {
          minLength: 'Bitte geben Sie mindestens 2 Zeichen ein.',
          required:  '{{ label }} ist ein Pflichtfeld.',
          maxLength: 'Bitte geben Sie maximal 300 Zeichen ein.'
        }
      },
      {
        id:            'beschreibung',
        placeholder:   'Bitte geben Sie eine Beschreibung ein',
        label:         'Beschreibung',
        type:          DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA,
        validators:    {
          maxLength: 500
        },
        errorMessages: {
          maxLength: 'Bitte geben Sie maximal 500 Zeichen ein.'
        }
      }
    ]
  }
];

export interface FormFactoryMap extends Record<string, FormModelFactory> {
}

export const FORM_FACTORIES: FormFactoryMap = {
  person: PERSON_FORM_MODEL,
  sache:  SACHE_FORM_MODEL,
  kfz:    KFZ_FORM_MODEL,
  tier:   TIER_FORM_MODEL
};
